export default {
  title: {
    color: "#2A2A2A",
    fontWeight: 600,
    marginBottom: "15px"
  },
  underline: {
    borderBottom: "2px solid #24b7cc",
    padding: "0px 16px 8px 0px"
  },
  uploadWrapper: {
    border: "2px dashed #C5C4C4",
    // padding: "5px",
    borderRadius: "5px",
    marginTop: "10px",
    width: "110px",
    height: "110px",
    "&:hover": {
      backgroundColor: "#fff"
    }
  },
  record: {
    width: "110px",
    height: "110px",
    marginRight: "10px",
    marginTop: "10px",
    borderRadius: "5px",
    backgroundColor: "#24b7cc"
  },
  recordSmall:{
    width: "110%",
    height: "110%",
    marginRight: "10px",
    marginTop: "10px",
    borderRadius: "5px",
    backgroundColor: "#24b7cc"
  },
  Btn: {
    marginRight: "20px",
    padding: "5px 20px"
  },
  icon: {
    margin: 'auto 0px 0px 0px',
    textAlign: 'center'
  },
  iconText: {
    margin: '0px 0px',
    textAlign: 'center'
  },
  buttonGrid: {
    marginTop: '20px',
    marginBottom: '50px',
    marginLeft: '12px',
    paddingLeft: '16px'
  },
  errorText: {
    color: "#f54040",
    marginLeft: '8px',
  },
  errorDiv: {
    width: '100%',
    height: '30px',
    lineHeight: '30px',
    marginTop: "20px",
    fontWeight: "bold",
    textAlign: "center"
  },
  videoName: {
    lineHeight: '50px',
    color: '#999999',
    margin: '20px',
    fontWeight: "bold",
    whiteSpace: "nowrap",
    overFlow: 'hidden',
    textOverflow: 'ellipsis',
  },
  videoNameDiv: {
    height: '50px',
    width: '290px',
    backgroundColor: '#fff',
    overflowX: "clip",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"

  },
  video: {
    // maxWidth: '290px',
     width:'100%',
     height: 'calc(100vh - 375px)',
     borderTopLeftRadius: '5px',
     borderTopRightRadius: '2px'
   },
   deleteButtonDiv: {
     width: '30px',
     height: '30px',
     borderRadius: '50%',
     backgroundColor: '#000',
     opacity: 0.5,
     right: '15px',
     zIndex: 999,
     top: '15px',
     position: 'absolute'
   },
   deleteIcon: {
     marginTop: '2px',
     marginLeft: '2px',
     color: "white"
   },
   videoBorder: {
     position: 'relative',
     flexDirection: 'row',
     boxShadow: '0 1px 2px 2px #9999992e',
     borderRadius: '2px'
   }
}
